<template>
    <div class="product-layout">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'product-layout'
}
</script>

<style scoped>
 .product-layout {
    height: 90vh;
 }
</style>



// WEBPACK FOOTER //
// src/components/Tienda/ProductLayout.vue